import * as React from 'react'
import styled, { css } from 'styled-components'
import { Link } from 'react-router-dom'

import Icon from '../Icon/Icon'

import menuSliderBackground from '../../../assets/img/menuSliderBackground.svg'
import ayalaMallsLogoMobile from '../../../assets/img/Ayala Malls-new-logo-mobile.png'

import LinkButton from '../LinkButton/LinkButton'

import media from '../../../services/generateMediaQueries'
import { doOpenSureSeats } from '../../../controllers/SSO'
import { setGACustomEvent } from '../../../services/analytics/google-analytics'

const StyledLinkButton = styled(LinkButton)`
  width: 100%;
  margin-bottom: 0.75rem;
`

const BlockLinkButton = styled(LinkButton)`
  width: 100%;
  background: #ffffff;
  border-color: #ffffff;
  color: var(--color-primary);
`

const StyledLink = styled(Link)`
  font-family: var(--font-family-ayala-display-sans);
  padding: 0 37px;
  width: 100%;
  letter-spacing: 1px;
  text-align: center;
`

const DefaultCloseButton = styled.button`
  display: none;
  position: absolute;
  border: 0;
  top: 15px;
  right: 15px;
  font-size: 30px;
  cursor: pointer;
  background: #ffffff;
  width: 40px;
  height: 40px;
  padding: 5px;
  border-radius: 100%;
  outline: none;
  z-index: 10000;
  color: #9b9b9b;

  > svg {
    vertical-align: baseline;
  }
`

const SideNavContainer = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  transition: all var(--animation-duration) var(--animation-easing);
  z-index: -998;

  ${props =>
    props.sideBarState &&
    css`
      z-index: 998;
      background: rgba(0, 0, 0, 0.5);
      transition: all var(--animation-duration) var(--animation-easing);
      ${DefaultCloseButton} {
        display: inline-block;
      }
    `}
`

const SideNav = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: fixed;
  width: 100%;
  max-width: 300px;
  height: 100%;
  overflow: auto;
  background: linear-gradient(-46deg, #173f35 0%, #4e6548 100%);
  transform: translateX(-300px);
  transition: all var(--animation-duration) var(--animation-easing);
  z-index: 999;
  top: 0;
  left: 0;

  ${props =>
    props.sideBarState &&
    css`
      transform: translateX(0);
      transition: all var(--animation-duration) var(--animation-easing);
    `}

  ${media.lessThan('xxsmall')`
    max-width: 255px;
  `}
`

const AwakenAmazingWrapper = styled.div`
  margin-top: 36px;
  text-align: center;
  margin-bottom: 2rem;
`

const AwakenAmazingLink = styled(Link)`
  margin-bottom: 57px;
  text-decoration: none;
  display: inline-block;
  :link {
    color: #fff;
  }

  :visited {
    color: #fff;
  }
`

const Description = styled.p`
  font-size: 0.75rem;
  letter-spacing: 0.25px;
  line-height: 1rem;
  max-width: 223px;
  margin: 0 auto;
  color: #ffffff;
  text-align: center;
`

const NavItem = styled.li`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  line-height: 5rem;
  min-height: 5rem;
  color: #ffffff;
  font-size: 1rem;
  font-weight: var(--font-weight-boldest);
  white-space: pre;
  cursor: pointer;
  transition: all var(--animation-duration) var(--animation-easing);

  ${props =>
    props.brand &&
    css`
      margin: 0 !important;
      width: 13.1875rem;
      justify-content: center;

      ${props.hasBackground &&
        css`
          background: var(--color-primary);
        `}

      &::after {
        display: none;
      }
    `}

  ${props =>
    props.burger &&
    css`
      width: 3.75rem;
    `}

  ${media.lessThan('large')`
    padding: 0 1.7vw;
  `}

  ${media.lessThan('medium')`
    line-height: 3.75rem;
    min-height: 3.75rem;
  `}


  ${props =>
    props.disabled &&
    css`
      cursor: default;
      * {
        cursor: default;
      }
    `}

  & > a {
    color: inherit;
    text-decoration: inherit;
  }

  &:hover {
    background: #ffffff;
    color: #000000;
    transition: all var(--animation-duration) var(--animation-easing);

    ${props =>
      props.disabled &&
      css`
        color: #fff;
        background: transparent;
      `}
  }
`

const ButtonContainer = styled.div`
  padding: 37px;
  z-index: 20;
`

const NavContainer = styled.div`
  flex-grow: 0;
  position: relative;
`

const NavItemContainer = styled.ul`
  margin: 0;
  padding: 0;
`

const StyledBannerImage = styled.div`
  text-align: center;
  display: block;
  width: 100%;

  img {
    display: block;
    max-width: 75%;
    height: auto;
    margin: 0 auto;
  }
`

class SideNavBar extends React.Component {
  state = {
    // TODO: define initial state
  }

  toggle = state => {
    const { sideBarToggle } = this.props

    sideBarToggle(state)
  }

  scrollTop = () => {
    const { sideBarToggle } = this.props

    sideBarToggle(false)
    window.scrollTo(0, 0)
  }

  moreSideBarToggle = () => {
    const { displayProfileModal } = this.props

    this.toggle(false)

    displayProfileModal(true)
  }

  handleClickCinema = async e => {
    e.preventDefault()
    await doOpenSureSeats()
  }

  handleClickTradeHall = async e => {
    window.location.href = '/trade-hall'
  }

  handleClickLeasingInquiry = async e => {
    window.location.href = '/leasing-inquiry'
  }

  render() {
    const { sideBarState, accessToken, selectedMallSlug } = this.props

    return (
      <>
        <SideNavContainer
          sideBarState={sideBarState}
          onClick={() => this.toggle(false)}
        >
          <DefaultCloseButton onClick={() => this.toggle(false)}>
            <Icon name="x" />
          </DefaultCloseButton>
        </SideNavContainer>
        <SideNav sideBarState={sideBarState}>
          <NavContainer>
            <AwakenAmazingWrapper>
              <AwakenAmazingLink to="/" onClick={this.scrollTop}>
                <StyledBannerImage>
                  <img src={ayalaMallsLogoMobile} alt="Ayala Malls" />
                </StyledBannerImage>
              </AwakenAmazingLink>
              <Description>
                Discover what’s new and what’s now in shopping, dining, and
                entertainment when you visit Ayala Malls.
              </Description>
            </AwakenAmazingWrapper>
            <NavItemContainer>
              <NavItem key="explore">
                <StyledLink
                  to={`/explore/${selectedMallSlug}`}
                  onClick={this.scrollTop}
                >
                  Explore
                </StyledLink>
              </NavItem>
              <NavItem key="promos-and-events">
                <StyledLink to="/promos-and-events" onClick={this.scrollTop}>
                  Promos &amp; Events
                </StyledLink>
              </NavItem>
              <NavItem>
                <StyledLink to="" onClick={this.handleClickCinema}>
                  Cinemas
                </StyledLink>
              </NavItem>
              {/*
              ST-7046 - Rewards :: Advanced : Remove Rewards Page
              <NavItem>
                <StyledLink to="/rewards" onClick={this.scrollTop}>
                  Rewards
                </StyledLink>
              </NavItem>
              */}
              <NavItem
                onClick={() => {
                  console.log('Trade Hall button clicked')

                  setGACustomEvent('button_cta', {
                    button_name: 'Trade_hall_button_home',
                  })
                }}
              >
                <StyledLink onClick={this.handleClickTradeHall}>
                  Trade Hall
                </StyledLink>
              </NavItem>
              <NavItem
                onClick={() => {
                  console.log('Leasing Inquiry button clicked')

                  setGACustomEvent('button_cta', {
                    button_name: 'Leasing_inquiry_button_home',
                  })
                }}
              >
                <StyledLink onClick={this.handleClickLeasingInquiry}>
                  Leasing Inquiry
                </StyledLink>
              </NavItem>
              <NavItem>
                <StyledLink onClick={this.moreSideBarToggle}>More</StyledLink>
              </NavItem>
            </NavItemContainer>
          </NavContainer>
          <ButtonContainer>
            {!accessToken && (
              <>
                <StyledLinkButton to="/register" variant="primary" small>
                  Join now
                </StyledLinkButton>
                <BlockLinkButton to="/login" small>
                  Login
                </BlockLinkButton>
              </>
            )}
          </ButtonContainer>
        </SideNav>
      </>
    )
  }
}

SideNavBar.defaultProps = {
  // TODO: specify default props
}

SideNavBar.propTypes = {
  // TODO: specify prop types
}

export default SideNavBar
